<template>
  <div>
    <v-form>
      <v-card color="grey lighten-2">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar class="baslik" size="120px" dark color="info">
              <v-toolbar-title> {{sayfabaslik}}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn @click="Kaydet()" v-if="kaydetbuton" flat> <span class="hidden-sm-and-down"> Kaydet </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <v-btn @click="FaturaGuncelle()" v-if="guncellebuton" flat> <span class="hidden-sm-and-down"> Güncelle
                </span>
                <v-icon right dark>create</v-icon>
              </v-btn>

              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile v-if="earsivdurum" @click="efaturagoster()">
                    <v-list-tile-title>Fatura Göster</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="earsivdurum" @click="earsivbilgigir()">
                    <v-list-tile-title>E-Arşiv Bilgi Girişi</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="guncellebuton">
                    <v-list-tile-title>Fatura No Değiştir</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="guncellebuton">
                    <v-list-tile-title>Fatura Tarih Değiştir</v-list-tile-title>
                  </v-list-tile>
                  <a target="_self" v-bind:href="'#/faturalar/faturalistesi'">
                    <v-list-tile>
                      <v-list-tile-title>Çıkış</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>

            </v-toolbar>
          </v-flex>
          <v-container fluid="">
            <v-layout row="" wrap>

              <v-expansion-panel :key="1">
                <v-expansion-panel-content style="background-color:#BDBDBD;" ripple :value="1">
                  <div slot="header">Serbest Fatura</div>
                  <v-card color="grey lighten-2">

                    <v-container fluid="">
                      <v-layout row="" wrap="">

                        <v-flex xs12 sm6 md3>
                          <v-layout justify-space-between column>
                            <div class="card__text grey darken-1 white--text">
                              <h3>Fatura Bilgileri</h3>
                            </div>
                            <v-layout>
                              <v-flex xs12 sm6 md6>
                                <v-text-field mask="AAAAAAAAAAAAAAAA" :disabled="seridisable" label="Fatura Seri No"
                                  :error-messages="errors.collect('carikod')" v-validate="'required'" data-vv-name="carikod"
                                  hide-details="" v-model="SerbestFatura.FaturaSeri" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md6>
                                <v-text-field hide-details="" type="number" :disabled="seridisable" label="Fatura No"
                                  :error-messages="errors.collect('carikod')" v-model="SerbestFatura.FaturaNo"
                                  v-validate="'required'" data-vv-name="carikod" required></v-text-field>
                              </v-flex>
                            </v-layout>


                            <v-autocomplete :items="faturatipi" clearable hide-details="" v-model="SerbestFatura.FaturaTip"
                              item-text="text" item-value="value" label=" Fatura  Tipi"></v-autocomplete>

                            <v-autocomplete hide-details="" :items="EvrakTipi1" v-bind="EvrakTipi1" item-text="Aciklama"
                              v-model="SerbestFatura.Evrak.Evrakkod" clearable item-value="Evrakkod" label="Evrak Tipi"></v-autocomplete>

                            <v-autocomplete hide-details="" clearable append-icon="search" label="Hesap Kodu" v-model="SerbestFatura.Cari.Kod"
                              @select="cariislemler()" :loading="loading" :items="statecari" item-text="text"
                              item-value="id" :search-input.sync="search1" cache-items=""></v-autocomplete>

                            <v-select v-if="gibserigoster" :items="gibseri" hide-details="" item-text="Seri" item-value="Seri"
                              clearable v-model="SerbestFatura.GibSeri" label=" Gib Seri"></v-select>


                            <tarihcomp :etiket="'Tarih'" :tabindex="'17'" :aktifmi="aktifdate" v-bind:value="SerbestFatura.Tarih"
                              v-model="SerbestFatura.Tarih"></tarihcomp>
                            <tarihcomp :etiket="'Vade'" :tabindex="'17'" :aktifmi="aktifdate" v-bind:value="SerbestFatura.Vade"
                              v-model="SerbestFatura.Vade"></tarihcomp>
                            <v-layout>
                              <v-autocomplete :items="referaslist" clearable item-value="Kod" item-text="ReferansAd"
                                label="Referans" hide-details="" v-model="SerbestFatura.Referans.Kod"></v-autocomplete>
                              <v-autocomplete :items="masrafmerkezi" hide-details="" clearable item-value="Code"
                                item-text="CodeName" v-model="SerbestFatura.Masraf.Code" label="Masraf Merkezi"></v-autocomplete>
                            </v-layout>
                            <v-text-field v-model="SerbestFatura.Aciklama" hide-details="" label="Açıklama" value=""></v-text-field>
                            <v-select :items="doviztipi" clearable hide-details="" item-text="DovizUnvan" item-value="DovizKod"
                              v-model="SerbestFatura.Doviz.DovizKod" @select="kurgetir()" label="Döviz Cinsi"></v-select>
                            <dovizinput v-model="SerbestFatura.Kur" :etiket="'Kur'" ::autocomplete="autocomplete"></dovizinput>
                            <v-select :items="Tevkifat" v-model="SerbestFatura.TevkivatKdv" item-text="text"
                              hide-details="" item-value="value" @blur="anatevkifatiptal()" clearable="" label=" Tevkifat KDV"
                              @select="anatevkifatkdvkontrol()"></v-select>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 md3>
                          <v-layout justify-space-between column>
                            <div class="card__text grey darken-1 white--text">
                              <h3>Ünvan ve Adres Bilgileri</h3>
                            </div>
                            <v-text-field hide-details="" label="Ünvan-1" v-model="SerbestFatura.EFaturaBilgi.Unvani"></v-text-field>
                            <v-text-field hide-details="" label="Ünvan-2" v-model="SerbestFatura.EFaturaBilgi.Unvani2"></v-text-field>
                            <v-text-field label="Adres-1" hide-details="" v-model="SerbestFatura.EFaturaBilgi.Adres1"></v-text-field>
                            <v-text-field label="Adres-2" hide-details="" v-model="SerbestFatura.EFaturaBilgi.Adres2"></v-text-field>
                            <v-text-field label="İlçe/İl" hide-details="" v-model="SerbestFatura.EFaturaBilgi.IlceSehir"></v-text-field>
                            <v-text-field hide-details="" autocomplete='email' label="Email" v-model="SerbestFatura.EFaturaBilgi.Email"></v-text-field>
                            <v-text-field hide-details="" label="Vergi Dairesi" v-model="SerbestFatura.EFaturaBilgi.VergiDairesi"></v-text-field>
                            <v-text-field hide-details="" label="Vergi No" v-model="SerbestFatura.EFaturaBilgi.VergiNo"></v-text-field>
                            <v-text-field hide-details="" mask="###########" label="T.C. Kimlik No" v-model="SerbestFatura.EFaturaBilgi.TcKimlikNo">
                            </v-text-field>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <v-layout justify-space-between column>
                            <div class="card__text grey darken-1 white--text">
                              <h3>T.C. İle İşlem Görenler İçin</h3>
                            </div>
                            <v-text-field hide-details="" label="Adı" v-model="SerbestFatura.EFaturaBilgi.Adi"></v-text-field>
                            <v-text-field hide-details="" label="Soyadı" v-model="SerbestFatura.EFaturaBilgi.Soyadi"></v-text-field>
                            <v-text-field hide-details="" label="Ünvanı " v-model="SerbestFatura.EFaturaBilgi.TUnvani"></v-text-field>
                            <v-text-field hide-details="" label="Diğer Adı" v-model="SerbestFatura.EFaturaBilgi.DigerAdi"></v-text-field>
                            <v-text-field hide-details="" label="Ön Adı Eki" v-model="SerbestFatura.EFaturaBilgi.OnAdiEki"></v-text-field>
                            <br>
                            <div class="card__text grey darken-1 white--text">
                              <h3>Seçenekler</h3>
                            </div>
                            <v-checkbox label="Dövizli Fatura" hide-details></v-checkbox>
                            <v-checkbox v-if="gibserigoster" label="Cariye Aktarma" v-model="SerbestFatura.CariAktarma"
                              hide-details></v-checkbox>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 md3>
                          <v-layout justify-space-between column>
                            <div class="card__text grey darken-1 white--text">
                              <h3>Fatura Tutar Bilgileri</h3>
                            </div>
                            <v-list two-line style="width:100%;">
                              <v-list-tile>
                                <v-list-tile-action>
                                  <v-icon color="indigo">assignment</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content style="width:10%">
                                  <v-list-tile-title>Toplam </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                  <v-list-tile-title>:{{SerbestFatura.Tutarlar.ToplamTutar.toFixed(2)}}
                                  </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                              <v-divider inset></v-divider>
                              <v-list-tile>
                                <v-list-tile-action>
                                  <v-icon color="indigo">trending_down</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content style="width:10%">
                                  <v-list-tile-title>İskonto </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                  <v-list-tile-title>:{{SerbestFatura.Tutarlar.Iskonto.toFixed(2)}} </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                              <v-divider inset></v-divider>
                              <v-list-tile>
                                <v-list-tile-action>
                                  <v-icon color="indigo">add</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content style="width:10%">
                                  <v-list-tile-title>Fat.Top. </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                  <v-list-tile-title>:{{SerbestFatura.Tutarlar.FaturaToplam.toFixed(2)}}
                                  </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                              <v-divider inset></v-divider>
                              <v-list-tile>
                                <v-list-tile-action>
                                  <v-icon color="indigo">add_to_photos</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content style="width:10%">
                                  <v-list-tile-title>K D V. &nbsp; </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                  <v-list-tile-title>:{{SerbestFatura.Tutarlar.Kdv.toFixed(2)}}</v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                              <v-divider inset></v-divider>
                              <v-list-tile>
                                <v-list-tile-action>
                                  <v-icon color="indigo">keyboard_arrow_down</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content style="width:10%">
                                  <v-list-tile-title>Tevkifat </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                  <v-list-tile-title>:{{SerbestFatura.Tutarlar.TevkifatKdv.toFixed(2)}}
                                  </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-list>
                            <h3 style="color:red;"> {{this.SerbestFatura.Efaturakayit}}</h3>
                            <h3 style="color:red;"> {{this.SerbestFatura.Earchiveakayit}}</h3>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-expansion-panel-content>

                <v-expansion-panel-content style="background-color:#BDBDBD;" :value="2" ripple="">
                  <div slot="header">Satır Girişi</div>
                  <v-card color="grey lighten-2">

                    <v-container fluid>
                      <v-flex xs12 sm4>
                        <v-btn color="info" @click="satirekle()"> Satır Ekle
                          <v-icon right dark>add_circle_outline</v-icon>
                        </v-btn>
                      </v-flex>


                      <v-dialog v-model="satirdialog" scrollable="" persistent="" max-width="800px">
                        <v-card color="grey lighten-2">
                          <v-card-title>Satır Girişi</v-card-title>
                          <v-divider></v-divider>
                          <v-card-text>

                            <v-layout row wrap="">


                              <v-flex xs12 sm6 md6>
                                <v-layout justify-space-between column>
                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.MuhasebeKodu" label="Muhasebe Kodu"></v-text-field>

                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.Aciklama" aria-multiline=""
                                    label="Açıklama"></v-text-field>

                                  <v-text-field v-model="SerbestFaturaDetay.LineNote" hide-details="" aria-multiline=""
                                    label="Line Note"></v-text-field>

                                  <v-select :items="referaslist" label="Referans" item-text="ReferansAd" hide-details=""
                                    v-model="SerbestFaturaDetay.Referans.Kod" item-value="Kod"></v-select>

                                  <v-select :items="masrafmerkezi" label="Masraf Merkezi" v-model="SerbestFaturaDetay.Masraf.Code"
                                    hide-details="" item-text="CodeName" clearable item-value="Code" max-height="400"></v-select>

                                  <v-text-field type="number" hide-details="" v-model="SerbestFaturaDetay.Miktar" label="Miktar"></v-text-field>

                                  <v-select v-model="SerbestFaturaDetay.Birim" hide-details="" label="Birim" item-text="text"
                                    item-value="value" :items="birim" persistent-hint></v-select>

                                  <parainput v-model="SerbestFaturaDetay.BirimFiyat" :etiket="'Birim Fiyat'"
                                    :autocomplete="autocomplete"></parainput>

                                  <parainput v-model="SerbestFaturaDetay.Tutar" v-on="change=tutardetayhesaplar()"
                                    :etiket="'Tutar'" :autocomplete="autocomplete"></parainput>

                                  <dovizinput v-model="SerbestFaturaDetay.DovizTutar" :etiket="'Döviz Tutar'"
                                    ::autocomplete="autocomplete"></dovizinput>


                                </v-layout>
                              </v-flex>



                              <v-flex xs12 sm6 md6>
                                <v-layout justify-space-between column>
                                  <v-select hide-details="" :items="kdvtipi" label="KDV Tipi" v-model="SerbestFaturaDetay.KdvTip"
                                    item-text="text" clearable item-value="value"></v-select>
                                  <v-layout>
                                    <v-text-field hide-details="" @blur="iskontohesapla()" label="İskonto Yüzde"
                                      v-model="SerbestFaturaDetay.IskontoYuzde"></v-text-field>


                                    <parainput v-model="SerbestFaturaDetay.IskontoTutar" v-on:change="iskontooranhesapla()"
                                      :etiket="'İskonto Tutar'" :autocomplete="autocomplete"></parainput>
                                  </v-layout>
                                  <v-layout>
                                    <v-text-field hide-details="" @blur="kdvhesapla()" v-model="SerbestFaturaDetay.KdvYuzde"
                                      label="KDV Yüzdesi"></v-text-field>

                                    <parainput v-model="SerbestFaturaDetay.KdvTutar" :etiket="'KDV Tutar'"
                                      :autocomplete="autocomplete"></parainput>
                                  </v-layout>

                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.KdvMuhKodu" label="KDV Muhasebe Kodu"></v-text-field>

                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.IskMuhKodu" label="İskonto Muhasebe Kodu"></v-text-field>

                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.KdvKodu" label="KDV Kodu"></v-text-field>

                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.IstisnaKodu" label="İstisna Kodu"></v-text-field>


                                  <v-select :items="Tevkifat" v-if="detaytevkifat" hide-details="" item-text="text"
                                    item-value="value" clearable v-model="SerbestFaturaDetay.TevkifatDetayOran" @select="Tevkifatkdvhesapla()"
                                    label=" Tevkifat KDV Oranı"></v-select>

                                  <parainput :aktif="'false'" v-if="detaytevkifat" v-model="SerbestFaturaDetay.TevkifatDetayTutar"
                                    :etiket="'Tev. KDV Tutar'" :autocomplete="autocomplete"></parainput>

                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.TevkifatKodu" label="Tevkifat Kodu"></v-text-field>
                                </v-layout>
                              </v-flex>


                              <v-flex v-if="ihracat" xs12 sm12 md12>
                                <v-layout justify-space-between column>
                                  <div class="card__text grey darken-1 white--text">
                                    <h3>İhracat Bilgileri</h3>
                                  </div>
                                </v-layout>
                              </v-flex>


                              <v-flex v-if="ihracat" xs12 sm6 md6>
                                <v-layout justify-space-between column>

                                  <v-text-field v-model="SerbestFaturaDetay.TeslimBilgileri.SokakAdi" hide-details=""
                                    label="Teslim Sokak"></v-text-field>

                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.BinaAdi"
                                    label="Teslim Bina"></v-text-field>

                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.BinaNo"
                                    label="Teslim Bina No"></v-text-field>

                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimSehir"
                                    label="Teslim İli"></v-text-field>

                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu"
                                    label="Teslim Posta Kodu"></v-text-field>

                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimUlke"
                                    label="Teslim Ülke"></v-text-field>

                                  <v-select label="Teslim Ödeme" clearable="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme"
                                    :items="teslimodeme"></v-select>

                                </v-layout>
                              </v-flex>


                              <v-flex v-if="ihracat" xs12 sm6 md6>
                                <v-layout justify-space-between column>

                                  <v-text-field v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimSarti" hide-details=""
                                    label="Teslim Şartı"></v-text-field>

                                  <v-text-field hide-details="" :error-messages="errors.collect('gtip')" v-validate="'min:4'"
                                    data-vv-name="gtip" v-model="SerbestFaturaDetay.TeslimBilgileri.GTIPNo" label="GTIP No"></v-text-field>

                                  <v-select :items="transferkodu" hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TransferKodu"
                                    label="Transfer Kodu" item-text="text" item-value="value" max-height="400"></v-select>

                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.KabinNo"
                                    label="Kabin No"></v-text-field>

                                  <v-text-field type="number" v-model="SerbestFaturaDetay.TeslimBilgileri.KabinAdedi"
                                    hide-details="" label="Kabin Adedi"></v-text-field>

                                  <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.KabinCinsi"
                                    label="Kabin Cinsi"></v-text-field>

                                </v-layout>
                              </v-flex>
                            </v-layout>

                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-btn color="blue darken-1" flat @click.native="satirdialog=false">İptal</v-btn>

                            <v-btn v-if="satirkaydetbuton" color="blue darken-1" flat @click.native="satirkaydet()">Kaydet</v-btn>


                            <v-btn v-if="satirguncellebuton" color="blue darken-1" flat @click.native="satirguncellekaydet()">Güncelle</v-btn>

                          </v-card-actions>
                        </v-card>
                      </v-dialog>


                      <v-dialog v-model="dialogearsiv" scrollable="" persistent="" max-width="400px">
                        <v-card color="grey lighten-2">
                          <v-card-title>E-Arşiv Bilgileri Girişi</v-card-title>
                          <v-divider></v-divider>
                          <v-card-text>
                            <v-layout row="" wrap="">
                              <div class="flex md12">
                                <v-select :items="gonderimsekli" v-model="SerbestFatura.EarsivBilgi.GonderimSekli"
                                  label="Gönderim Şekli" item-text="text" item-value="value" max-height="400"></v-select>
                                <v-select v-model="SerbestFatura.EarsivBilgi.InternetSatis" :items="odemesekli" label="İnternet Satış"
                                  item-text="text" item-value="value" max-height="400" persistent-hint></v-select>


                                <v-select :items="webadresleri" v-model="SerbestFatura.EarsivBilgi.WebAdresi" label="Web Adresi"
                                  item-text="Aciklama" clearable item-value="ID" max-height="400"></v-select>



                                <v-select :items="odemesekli1" v-model="SerbestFatura.EarsivBilgi.OdemeSekli" label="Ödeme Şekli"
                                  item-text="text" clearable item-value="value" max-height="400"></v-select>


                                <v-select :items="odemesekilleri" v-model="SerbestFatura.EarsivBilgi.OdemeSekliAciklama"
                                  label="Ödeme Şekli Açıklama" item-text="Aciklama" clearable item-value="ID"
                                  max-height="400"></v-select>

                                <v-select :items="odemearaci" v-model="SerbestFatura.EarsivBilgi.OdemeAraci" label="Ödeme Aracı"
                                  item-text="Aciklama" clearable item-value="ID" max-height="400" persistent-hint></v-select>



   <tarihcomp :etiket="'Ödeme Tarih'" :tabindex="'17'"  v-bind:value="datearsiv"
                              v-model="datearsiv"></tarihcomp>


                              </div>
                            </v-layout>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn color="blue darken-1" flat @click.native="dialogearsiv=false">İptal</v-btn>
                            <v-btn color="blue darken-1" flat @click.native="dialogearsiv=false">Kaydet</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <div class="flex xs12 sm12 xs12">
                        <v-flex xs12 sm12>
                          <v-card-title>
                            <v-spacer></v-spacer>
                          </v-card-title>
                          <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="satiritems"
                            :search="search3">
                            <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                            <template slot="items" slot-scope="props">
                              <tr item>
                                <td class="text-xs-left">{{ props.item.MuhasebeKodu }}</td>
                                <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                                <td class="text-xs-left">{{ props.item.Referans.Kod }}</td>
                                <td class="text-xs-left">{{ props.item.Tutar}}</td>
                                <td class="text-xs-left">{{ props.item.DovizTutar }}</td>
                                <td class="text-xs-left">{{ props.item.KdvYuzde }}</td>
                                <td class="text-xs-left">{{ props.item.KdvTutar }}</td>
                                <td class="text-xs-left">{{ props.item.Tip }}</td>
                                <td class="text-xs-left">{{ props.item.IskontoYuzde }}</td>
                                <td class="justify-center layout px-0">
                                  <v-btn icon class="mx-0" @click="satirduzenle(props.item)">
                                    <v-icon color="teal">edit</v-icon>
                                  </v-btn>
                                  <v-btn icon class="mx-0" @click="satirsil(props.item)">
                                    <v-icon color="pink">delete</v-icon>
                                  </v-btn>
                                </td>
                              </tr>
                            </template>
                            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                              Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                            </v-alert>
                          </v-data-table>
                        </v-flex>
                      </div>
                      <v-card>
                        <v-layout row wrap>
                        </v-layout>
                      </v-card>
                    </v-container>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-layout>
          </v-container>
        </v-layout>
      </v-card>
    </v-form>
    <v-dialog v-model="faturadialog" scrollable="" max-width="850px">
      <v-card>
        <v-card-title>E-Fatura</v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row wrap="">

            <div class="flex md12">
              <span id="demo2">
              </span>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loadingdialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Fatura bilginiz getiriliyor... Lütfen Bekleyiniz.
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import dovizinput from '../customcomp/dovizinput'
  import yuzdeinput from '../customcomp/yuzdeinput'
  import tarihcomp from '../customcomp/tarihcomp'



  export default {

    props: {
      operation: ''
    },

    data() {
      return {
        headers: [{
            text: 'Muh. Kod',
            value: 'MuhasebeKodu'
          },
          {
            text: 'Açıklama ',
            value: 'Aciklama',

          },
          {
            text: 'Referans',
            value: 'Referans.Kod'
          },
          {
            text: 'Tutar',
            value: 'Tutar',
          },
          {
            text: 'Döviz Tutar',
            value: 'DovizTutar',
          },
          {
            text: 'KDV Yüzde',
            value: 'KdvYuzde',
          },
          {
            text: 'KDV Tutar',
            value: 'KdvTutar',
          },
          {
            text: 'Tip',
            value: 'Tip',
          },
          {
            text: 'İskonto Yüzde ',
            value: 'IskontoYuzde',
          },
          {
            text: 'İşlem ',
            value: '',
          }
        ],
        gibserigoster: true,
        autocomplete: 'autocomplete',
        drawer: null,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        yok: false,
        statesecili: [{
          Kod: 'Kod',
          Unvan: 'Unvan',
          newProp: 'Kod' + ' - ' + 'Unvan'
        }],
        statecari: [],
        secilensatirno: -1,
        search3: '',
        search1: '',
        loading: false,
        caritext: '',
        cariid: '',
        aktifdate: false,
        nefaturasi: null,

        SerbestFatura: {
          SirketKodu: '',
          SerbestFaturaDetay: [],
          Serbest: true,
          AlisSatis: false,
          FaturaSeri: '',
          FaturaNo: '',
          Update: false,
          FaturaTip: '', // 0 : Satış faturası , 1 : Iade Faturası
          Evrak: {
            Evrakkod: ''
          },
          Cari: {
            Kod: ''
          },
          EFaturaBilgi: {
            Unvani: '',
            Unvani2: '',
            Adres1: '',
            Adres2: '',
            IlceSehir: '',
            Email: '',
            VergiDairesi: '',
            VergiNo: '',
            TcKimlikNo: '',
            Adi: '',
            Soyadi: '',
            TUnvani: '',
            DigerAdi: '',
            OnAdiEki: '',
          },
          Tarih: '',
          GibSeri: '',
          Vade: '',
          Referans: {
            Kod: ''
          },
          Masraf: {
            Code: ''
          },
          Aciklama: '',
          Doviz: {
            DovizKod: ''
          },
          Kur: 0,
          TevkivatKdv: 0,
          FaturaID: 0,
          CariAktarma: false,
          Tutarlar: {
            ToplamTutar: 0,
            Iskonto: 0,
            FaturaToplam: 0,
            Kdv: 0,
            TevkifatKdv: 0
          },
          Efaturakayit: '',
          Earchiveakayit: '',
          EarsivBilgi: {
            GonderimSekli: '',
            InternetSatis: '',
            pWebAdresi: '',
            OdemeSekli: '',
            OdemeSekliAciklama: '',
            OdemeAraci: '',
            OdemeTarihi: ''
          },
          EFaturaShowID: {
            EFaturaID: null,
            EFaturaGuid: null
          }
        },

        SerbestFaturaDetayList: [],

        SerbestFaturaDetay: {
          MuhasebeKodu: '',
          Aciklama: '',
          LineNote: '',
          Referans: {
            Kod: ''
          },
          Masraf: {
            Code: ''
          },
          Miktar: 0,
          Birim: '',
          BirimFiyat: 0,
          Tutar: 0,
          DovizTutar: 0,
          IskontoYuzde: 0,
          IskontoTutar: 0,
          KdvTip: '',
          KdvYuzde: 0,
          KdvTutar: 0,
          KdvMuhKodu: '',
          IskMuhKodu: '',
          KdvKodu: '',
          IstisnaKodu: '',
          TevkifatKodu: '',
          Tip: '',
          TevkifatDetayTutar: 0,
          TevkifatDetayOran: 0,

          TeslimBilgileri: {
            SokakAdi: '',
            BinaAdi: '',
            BinaNo: '',
            TeslimSehir: '',
            TeslimPostaKodu: '',
            TeslimUlke: '',
            TeslimSarti: '',
            GTIPNo: '',
            TransferKodu: '',
            KabinNo: '',
            KabinAdedi: '',
            KabinCinsi: '',
            TeslimOdeme: ''
          }

        },

        SerbestFaturaToplamTutarBilgileri: {
          ToplamTutar: 0,
          Iskonto: 0,
          FaturaToplam: 0,
          Kdv: 0,
          TevkifatKdv: 0
        },

        birim: [{
            text: 'adet',
            value: 'adet'
          },
          {
            text: 'kilo',
            value: 'kilo'
          }, {
            text: 'gram',
            value: 'gram'
          }, {
            text: 'metre',
            value: 'metre'
          },
          {
            text: 'Cm',
            value: 'Cm'
          },
        ],
        faturatipi: [{
            text: 'Satış Faturası',
            value: 0
          },
          {
            text: 'İade Faturası',
            value: 1
          }
        ],
        gonderimsekli: [{
            text: 'Kağıt',
            value: 0
          },
          {
            text: 'Elektronik',
            value: 1
          }
        ],
        odemesekli: [{
            text: 'Normal Satış',
            value: 0
          },
          {
            text: 'İnternet Satış',
            value: 1
          }
        ],
        seridisable: false,
        faturagosterbtn: false,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',

        datearsiv: null,
        menuarsiv: false,
        modalarsiv: false,
        dateFormattedarsiv: '',
        yedeksatirkayit: {
          Tutar: 0,
          Kdv: 0,
          Tevkifat: 0,
          iskonto: 0
        },
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        ihracat: false,
        progress: false,
        satirdialog: false,

        gibseri: [],
        satiritems: [],
        referaslist: [],
        EvrakTipi1: [],
        kdvtipi: [{
            text: 'D',
            value: 'D'
          },
          {
            text: 'H',
            value: 'H'
          }
        ],
        Tevkifat: [{
            text: '0/10',
            value: '0'
          },
          {
            text: '1/10',
            value: '0.1'
          },
          {
            text: '2/10',
            value: '0.2'
          },
          {
            text: '3/10',
            value: '0.3'
          },
          {
            text: '4/10',
            value: '0.4'
          },
          {
            text: '5/10',
            value: '0.5'
          },
          {
            text: '6/10',
            value: '0.6'
          },
          {
            text: '7/10',
            value: '0.7'
          },
          {
            text: '8/10',
            value: '0.8'
          },
          {
            text: '9/10',
            value: '0.9'
          },
          {
            text: '10/10',
            value: '1'
          }
        ],

        odemesekli1: [{
            text: 'Kredi-Banka Kartı',
            value: '0'
          },
          {
            text: 'EFT-Havale',
            value: '1'
          },
          {
            text: 'Kapıda Ödeme',
            value: '2'
          },
          {
            text: 'Ödeme Aracısı',
            value: '3'
          },
          {
            text: 'Diğer',
            value: '4'
          }
        ],

        transferkodu: [{
            text: 'Deniz Yolu',
            value: '1'
          },
          {
            text: 'Demir Yolu',
            value: '2'
          },
          {
            text: 'Karayolu',
            value: '3'
          },
          {
            text: 'Havayolu',
            value: '4'
          },
          {
            text: 'Posta',
            value: '5'
          },
          {
            text: 'Çok Araçlı',
            value: '6'
          },
          {
            text: 'Sabit Taşıma Tesisleri',
            value: '7'
          },
          {
            text: 'İç Su Taşımacılığı',
            value: '8'
          }
        ],

        teslimodeme: [{
            text: 'Instrument not defined',
            value: 1
          },
          {
            text: 'Automated clearing house credit',
            value: 2
          },
          {
            text: 'Automated clearing house debit',
            value: 3
          },
          {
            text: 'ACH demand debit reversal',
            value: 4
          },
          {
            text: 'ACH demand credit reversal',
            value: 5
          },
          {
            text: 'ACH demand credit',
            value: 6
          },
          {
            text: 'ACH demand debit',
            value: 7
          },
          {
            text: 'Hold',
            value: 8
          },
          {
            text: 'National or regional clearing',
            value: 9
          },
          {
            text: 'In cash',
            value: 10
          },
          {
            text: 'ACH savings credit reversal',
            value: 11
          },
          {
            text: 'ACH savings debit reversal',
            value: 12
          },
          {
            text: 'ACH savings credit',
            value: 13
          },
          {
            text: 'ACH savings debit',
            value: 14
          },
          {
            text: 'Bookentry credit',
            value: 15
          },
          {
            text: 'Bookentry debit',
            value: 16
          },
          {
            text: 'ACH demand cash concentration/disbursement (CCD) credit',
            value: 17
          },
          {
            text: 'ACH demand cash concentration/disbursement (CCD) debit',
            value: 18
          },
          {
            text: 'ACH demand corporate trade payment (CTP) credit',
            value: 19
          },
          {
            text: 'Cheque',
            value: 20
          },
          {
            text: 'Bankers draft',
            value: 21
          },
          {
            text: 'Certified bankers draft',
            value: 22
          },
          {
            text: 'Bank cheque (issued by a banking or similar establishment)',
            value: 23
          },
          {
            text: 'Certified cheque',
            value: 25
          },
          {
            text: 'Local cheque',
            value: 26
          },
          {
            text: 'ACH demand corporate trade payment (CTP) debit',
            value: 27
          },
          {
            text: 'ACH demand corporate trade exchange (CTX) credit',
            value: 28
          },
          {
            text: 'ACH demand corporate trade exchange (CTX) debit',
            value: 29
          },
          {
            text: 'Credit transfer',
            value: 30
          },
          {
            text: 'Debit transfer',
            value: 31
          },
          {
            text: 'ACH demand cash concentration/disbursement plus (CCD+)',
            value: 32
          },
          {
            text: 'ACH demand cash concentration/disbursement plus (CCD+)',
            value: 33
          },
          {
            text: 'ACH prearranged payment and deposit (PPD)',
            value: 34
          },
          {
            text: ' ACH savings cash concentration/disbursement (CCD) credit',
            value: 35
          },
          {
            text: 'ACH savings cash concentration/disbursement (CCD) debit',
            value: 36
          },
          {
            text: 'ACH savings corporate trade payment (CTP) credit',
            value: 37
          },
          {
            text: 'ACH savings corporate trade payment (CTP) debit',
            value: 38
          },
          {
            text: 'ACH savings corporate trade exchange (CTX) credit',
            value: 39
          },
          {
            text: 'ACH savings corporate trade exchange (CTX) debit',
            value: 40
          },
          {
            text: 'ACH savings cash concentration/disbursement plus (CCD+)',
            value: 41
          },
          {
            text: 'Payment to bank account',
            value: 42
          },
          {
            text: 'ACH savings cash concentration/disbursement plus (CCD+)',
            value: 43
          },
          {
            text: 'Accepted bill of exchange',
            value: 44
          },
          {
            text: 'Referenced home-banking credit transfer',
            value: 45
          },
          {
            text: 'Interbank debit transfer',
            value: 46
          },
          {
            text: 'Home-banking debit transfer',
            value: 47
          },
          {
            text: 'Bank card',
            value: 48
          },
          {
            text: 'Direct debit',
            value: 49
          },
          {
            text: 'Payment by postgiro',
            value: 50
          },
          {
            text: 'Promissory note',
            value: 60
          },
          {
            text: '61    Promissory note signed by the debtor',
            value: 61
          },
          {
            text: 'Promissory note signed by the debtor and endorsed by a bank',
            value: 62
          },
          {
            text: 'Promissory note signed by the debtor and endorsed by a',
            value: 63
          },
          {
            text: ' Promissory note signed by a bank',
            value: 64
          },
          {
            text: 'Promissory note signed by a bank and endorsed by another',
            value: 65
          },
          {
            text: 'Promissory note signed by a third party',
            value: 66
          },
          {
            text: 'Promissory note signed by a third party and endorsed by a',
            value: 67
          },
          {
            text: 'Bill drawn by the creditor on the debtor',
            value: 70
          },
          {
            text: 'Bill drawn by the creditor on a bank',
            value: 74
          },
          {
            text: 'Bill drawn by the creditor, endorsed by another bank',
            value: 75
          },
          {
            text: 'Bill drawn by the creditor on a bank and endorsed by a',
            value: 76
          },
          {
            text: 'Bill drawn by the creditor on a third party',
            value: 77
          },
          {
            text: 'Bill drawn by creditor on third party, accepted and',
            value: 78
          },
          {
            text: 'Not transferable banker s draft',
            value: 91
          },
          {
            text: 'Not transferable local cheque',
            value: 92
          },
          {
            text: 'Reference giro',
            value: 93
          },
          {
            text: 'Urgent giro',
            value: 94
          },
          {
            text: 'Free format giro',
            value: 95
          },
          {
            text: 'Requested method for payment was not used',
            value: 96
          },
          {
            text: 'Clearing between partners',
            value: 97
          }

        ],

        efaturatipi: [{
            text: 'Ticari',
            value: '0'
          },
          {
            text: 'Temel',
            value: '1'
          },
          {
            text: 'İhracat',
            value: '2'
          }
        ],

        islembilgileri: [{
            text: 'Kağıt Fatura',
            value: 'false'
          },
          {
            text: 'Elektronik Fatura',
            value: 'true'
          }
        ],

        doviztipi: [],
        webadresleri: [],
        odemesekilleri: [],
        odemearaci: [],

        ichattipi: [
          'D', 'D-', 'D+', 'K', 'K-', 'K+', 'U', 'U-', 'U+', 'L', 'L-', 'L+'
        ],

        evethayir: [{
            text: 'Evet',
            value: 'E'
          },
          {
            text: 'Hayır',
            value: 'H'
          },
        ],

        cmkodu: [
          'C', 'M'
        ],

        masrafmerkezi: [],
        dictionary: {
          custom: {
            carikod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            unvan: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            gtip: {
              min: () => 'En az 4 haneli olmalı',
            }

          }
        },
        sayfabaslik: 'Serbest Fatura',
        satirguncellebuton: false,
        satirkaydetbuton: true,
        StartDate: null,
        EndDate: null,
        NumberOfPolicies: '',
        PolicySum: '',
        TotalDebt: '',
        TotalFlatDebt: '',
        kaydetbuton: true,
        guncellebuton: false,
        silbuton: false,
        detaytevkifat: true,
        text1: '',
        denemevalue: 0,

        biletlerfaturalanmasin: null,
        efaturamukellefi: null,
        loadingdialog: false,
        Kdvmuaf: null,
        ciktiistemiyor: null,
        musteribilgitipi: null,
        profilzorunlu: null,
        eventidzorunlu: null,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        carikod: '',
        unvan: '',
        active: '',
        ex11: 'false',
        dialogearsiv: false,
        earsivdurum: false,
        guidim: null,
        idim: null,
        faturadialog: false,

      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      formatDate(date) {

        var str = date
        var n = str.search('.')
        if (n == 1) {
          //  return null
        } else {


          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      formatDate2(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {

          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },

      satirguncellekaydet() {

        const index = this.secilensatirno

        this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar - this.yedeksatirkayit.Tutar
        this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv - this.yedeksatirkayit.Kdv
        this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv - this.yedeksatirkayit.Tevkifat
        this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto - this.yedeksatirkayit.iskonto

        //  this.satiritems.splice(index, 1)

        if (this.SerbestFaturaDetay.DovizTutar > 0) {
          var n = this.SerbestFaturaDetay.DovizTutar
          //  this.SerbestFaturaDetay.DovizTutar = n.toFixed(4)

        }

        var satiryeni = {
          TeslimBilgileri: {
            SokakAdi: this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi,
            BinaAdi: this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi,
            BinaNo: this.SerbestFaturaDetay.TeslimBilgileri.BinaNo,
            TeslimSehir: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir,
            TeslimPostaKodu: this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu,
            TeslimUlke: this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke,
            TeslimSarti: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti,
            GTIPNo: this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo,
            TransferKodu: this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu,
            KabinNo: this.SerbestFaturaDetay.TeslimBilgileri.KabinNo,
            KabinAdedi: this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi,
            KabinCinsi: this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi,
            TeslimOdeme: this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme
          },
          MuhasebeKodu: this.SerbestFaturaDetay.MuhasebeKodu,
          Aciklama: this.SerbestFaturaDetay.Aciklama,
          Referans: {
            Kod: this.SerbestFaturaDetay.Referans.Kod
          },
          Masraf: {
            Code: this.SerbestFaturaDetay.Masraf.Code
          },
          Miktar: this.SerbestFaturaDetay.Miktar,
          LineNote: this.SerbestFaturaDetay.LineNote,
          Birim: this.SerbestFaturaDetay.Birim,
          BirimFiyat: this.SerbestFaturaDetay.BirimFiyat,
          Tutar: this.SerbestFaturaDetay.Tutar,
          TevkifatDetayTutar: this.SerbestFaturaDetay.TevkifatDetayTutar,
          DovizTutar: this.SerbestFaturaDetay.DovizTutar,
          TevkifatDetayOran: this.SerbestFaturaDetay.TevkifatDetayOran,
          IskontoYuzde: this.SerbestFaturaDetay.IskontoYuzde,
          IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
          KdvKodu: this.SerbestFaturaDetay.KdvKodu,
          KdvMuhKodu: this.SerbestFaturaDetay.KdvMuhKodu, //
          IskMuhKodu: this.SerbestFaturaDetay.IskMuhKodu, //
          KdvTutar: this.SerbestFaturaDetay.KdvTutar,
          KdvTip: this.SerbestFaturaDetay.KdvTip,
          KdvYuzde: this.SerbestFaturaDetay.KdvYuzde,
          IstisnaKodu: this.SerbestFaturaDetay.IstisnaKodu,
          TevkifatKodu: this.SerbestFaturaDetay.TevkifatKodu,
          Tip: this.SerbestFaturaDetay.Tip,
          AdresBilgi: {
            Unvani: null,
            Unvani2: null,
            Adres1: null,
            Adres2: null,
            IlceSehir: null,
            Email: null,
            VergiDairesi: null,
            VergiNo: null,
            TcKimlikNo: null,
            Adi: null,
            Soyadi: null,
            TUnvani: null,
            DigerAdi: null,
            OnAdiEki: null
          },
          EfaturaDetayBilgileri: {
            SiparisID: null,
            SiparisTarihi: null
          },
          AdresBilgi: {
            Unvani: null,
            Unvani2: null,
            Adres1: null,
            Adres2: null,
            IlceSehir: null,
            Email: null,
            VergiDairesi: null,
            VergiNo: null,
            TcKimlikNo: null,
            Adi: null,
            Soyadi: null,
            TUnvani: null,
            DigerAdi: null,
            OnAdiEki: null
          }
        }

        var yedeksatiritems = []
        yedeksatiritems = this.satiritems
        this.satiritems = []

        for (var i = 0; i < yedeksatiritems.length; i++) {
          if (index == i) {
            this.satiritems.push(satiryeni)
          } else {
            this.satiritems.push(yedeksatiritems[i])
          }
        }

        this.SerbestFaturaDetayList = this.satiritems
        console.log(this.SerbestFaturaDetayList)
        // this.satiritems.push(satiryeni)

        this.satirdialog = false
        this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar + satiryeni.Tutar
        this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv + satiryeni.KdvTutar
        this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv + satiryeni.TevkifatDetayTutar
        this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto + satiryeni.IskontoTutar
        this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.ToplamTutar -
          this.SerbestFatura.Tutarlar.Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv

      },

      satirduzenle(params) {

        this.yedeksatirkayit.Tutar = params.Tutar
        this.yedeksatirkayit.Kdv = params.KdvTutar
        this.yedeksatirkayit.iskonto = params.IskontoTutar
        this.yedeksatirkayit.Tevkifat = params.TevkifatDetayTutar

        this.secilensatirno = this.satiritems.indexOf(params)

        this.SerbestFaturaDetay = params
        this.satirdialog = true
        this.satirguncellebuton = true
        this.satirkaydetbuton = false
      },
      satirsil(item) {

        const index = this.satiritems.indexOf(item)
        var r = confirm('Kayıtı silmek istiyor musunuz?')
        if (r == true) {
          this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar - item.Tutar
          this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv - item.KdvTutar
          this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv - item.TevkifatDetayTutar
          this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto - item.IskontoTutar
          this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.ToplamTutar - this.SerbestFatura.Tutarlar
            .Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv
          this.satiritems.splice(index, 1)
        } else {

        }
      },

      cariislemler() {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'))

        var params = {
          Code: this.SerbestFatura.Cari.Kod,
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/Current/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.SerbestFatura.EFaturaBilgi.Unvani = response.body.Title
          //this.SerbestFatura.EFaturaBilgi.Unvani2 = this.statecari[0].Unvani2
          this.SerbestFatura.EFaturaBilgi.Adres1 = response.body.Invoice.Address
          //this.SerbestFatura.EFaturaBilgi.Adres2 = this.statecari[0].Adres2
          this.SerbestFatura.EFaturaBilgi.IlçeSehir = response.body.Invoice.Province
          this.SerbestFatura.EFaturaBilgi.Email = response.body.Email
          this.SerbestFatura.EFaturaBilgi.VergiDairesi = response.body.Invoice.TaxOffice
          this.SerbestFatura.EFaturaBilgi.VergiNo = response.body.Invoice.TaxNumber
          this.SerbestFatura.EFaturaBilgi.TcKimlikNo = response.body.Invoice.IdentityNumber
          this.SerbestFatura.EFaturaBilgi.Adi = response.body.Invoice.PerFirstName
          this.SerbestFatura.EFaturaBilgi.Soyadi = response.body.Invoice.PerfamilyName
          this.SerbestFatura.EFaturaBilgi.TUnvani = response.body.Invoice.PerTitle
          this.SerbestFatura.EFaturaBilgi.DigerAdi = response.body.Invoice.PerMiddleName
          this.SerbestFatura.EFaturaBilgi.OnAdiEki = response.body.Invoice.PerNameSuffix

        }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params1 = {
          SirketKodu: credentials.SirketKodu,
          CariKodu: this.SerbestFatura.Cari.Kod
        }

        this.$http.post(auth.API_URL + 'api/Helpers/GetEInvoiceArchiveInfo', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.IhracatFatura === true) {
            this.ihracat = true
          } else {
            this.ihracat = false
          }
          if (response.body.EFatura === true) {

            var params1 = {
              CompanyCode: credentials.SirketKodu
            }

            this.SerbestFatura.Efaturakayit = 'E-Fatura Kayıtlı'

            this.$http.post(auth.API_URL + 'api/Definitions/GibSerialList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.gibseri = response.body
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })
          } else {
            this.SerbestFatura.Efaturakayit = 'E-Fatura Kayıtlı Değil'
          }

          if (response.body.Earsiv === true) {
            this.SerbestFatura.Earchiveakayit = 'E-Arşiv Kayıtlı'
            this.earsivdurum = true

            var params1 = {
              CompanyCode: credentials.SirketKodu
            }
            this.$http.post(auth.API_URL + 'api/Definitions/GibSerialEarchiveList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.gibseri = response.body
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })


          } else {
            this.SerbestFatura.Earchiveakayit = 'E-Arşiv Kayıtlı Değil'
            this.earsivdurum = true

          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-GetEInvoiceArchiveInfo'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-GetEInvoiceArchiveInfo'
            this.snackbar = true
          }
        })

      },
      guncelle: guncelle,
      satirekle: satirekle,
      ekle: ekle,
      getDateNow: getDateNow,
      getDateNow1: getDateNow1,
      toDateformat: toDateformat,
      carigetir: carigetir,
      Kaydet: Kaydet,
      satirkaydet: satirkaydet,
      kdvhesapla: kdvhesapla,
      iskontohesapla: iskontohesapla,
      iskontooranhesapla: iskontooranhesapla,
      Tevkifatkdvhesapla: Tevkifatkdvhesapla,
      anatevkifatkdvkontrol: anatevkifatkdvkontrol,
      anatevkifatiptal: anatevkifatiptal,
      kurgetir: kurgetir,
      tutardetayhesaplar: tutardetayhesaplar,
      earsivbilgigir: earsivbilgigir,
      FaturaGuncelle: FaturaGuncelle,
      efaturagoster: efaturagoster
    },
    beforeMount: beforeMount,
    components: {
      'parainput': parainput,
      'dovizinput': dovizinput,
      'yuzdeinput': yuzdeinput,
      'tarihcomp': tarihcomp
    },
    watch: {
      search1(val) {
        val && this.carigetir(val)
      },

      'SerbestFaturaDetay.BirimFiyat': function () {

        if (this.SerbestFaturaDetay.Miktar > 0 && this.SerbestFaturaDetay.BirimFiyat >= 0) {
          this.SerbestFaturaDetay.Tutar = this.SerbestFaturaDetay.Miktar * this.SerbestFaturaDetay.BirimFiyat
        } else {
          this.SerbestFaturaDetay.Tutar = 0
        }
      },
      'SerbestFaturaDetay.Miktar': function () {

        if (this.SerbestFaturaDetay.Miktar > 0 && this.SerbestFaturaDetay.BirimFiyat >= 0) {
          this.SerbestFaturaDetay.Tutar = this.SerbestFaturaDetay.Miktar * this.SerbestFaturaDetay.BirimFiyat
        } else {
          this.SerbestFaturaDetay.Tutar = 0
        }
      },
    }
  }


  function efaturagoster() {

    var params = {
      id: this.idim,
      guid: this.guidim
    }


    this.$http.post(auth.API_URL + 'api/EFatura/FaturaShow', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.faturadialog = true
      document.getElementById("demo2").innerHTML = response.body;
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })


  }


  function tutardetayhesaplar() {

    if (this.SerbestFatura.Kur != null && this.SerbestFatura.Kur != 0 && this.SerbestFatura.Kur != '' && this.SerbestFaturaDetay
      .Tutar != 0) {
      this.SerbestFaturaDetay.DovizTutar = this.SerbestFaturaDetay.Tutar / this.SerbestFatura.Kur
    }

    if (this.SerbestFaturaDetay.IskontoYuzde != null && this.SerbestFaturaDetay.IskontoYuzde != '') {

      var params1 = {
        Tutar: this.SerbestFaturaDetay.Tutar,
        IskontoOran: this.SerbestFaturaDetay.IskontoYuzde
      }

      this.$http.post(auth.API_URL + 'api/Helpers/GetDiscountAmount', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SerbestFaturaDetay.IskontoTutar = response.body.IskontoTutar
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-Iskonto Hesapla'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable-Iskonto Hesapla'
          this.snackbar = true
        }
      })
    } else {
      this.SerbestFaturaDetay.KdvTip != null
      this.SerbestFaturaDetay.IskontoYuzde = 0
      this.SerbestFaturaDetay.IskontoTutar = 0
    }

    if (this.SerbestFaturaDetay.IskontoTutar != null && this.SerbestFaturaDetay.IskontoTutar != '' && this.SerbestFaturaDetay
      .KdvYuzde != null && this.SerbestFaturaDetay.KdvYuzde != '') {
      var params1 = {
        KdvTip: this.SerbestFaturaDetay.KdvTip,
        Tutar: this.SerbestFaturaDetay.Tutar,
        IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
        KdvOran: this.SerbestFaturaDetay.KdvYuzde
      }

      this.$http.post(auth.API_URL + 'api/Helpers/GetTaxAmount', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SerbestFaturaDetay.KdvTutar = response.body.KdvTutar
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-Kdv Hesapla'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable-Kdv Hesapla'
          this.snackbar = true
        }
      })
    } else {
      this.SerbestFaturaDetay.KdvYuzde = 0
      this.SerbestFaturaDetay.KdvTutar = 0
    }

    if (this.SerbestFaturaDetay.TevkifatDetayOran != null && this.SerbestFaturaDetay.TevkifatDetayOran != '' && this.SerbestFaturaDetay
      .KdvTutar != '' && this.SerbestFaturaDetay.KdvTutar != null && this.detaytevkifat == true) {

      var params1 = {
        TevkifatOran: this.SerbestFaturaDetay.TevkifatDetayOran,
        KdvTutar: this.SerbestFaturaDetay.KdvTutar
      }

      this.$http.post(auth.API_URL + 'api/Helpers/GetWithHoldingAmount', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SerbestFaturaDetay.TevkifatDetayTutar = response.body.TevkifatTutar
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-Iskonto Hesapla'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable-Iskonto Hesapla'
          this.snackbar = true
        }
      })
    } else {
      this.SerbestFaturaDetay.TevkifatDetayOran = '0.0'
    }

  }

  function kurgetir() {

    var params1 = {
      Tarih: this.SerbestFatura.Tarih,
      DovizKod: this.SerbestFatura.Doviz.DovizKod
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetRate', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFatura.Kur = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })

  }

  function anatevkifatkdvkontrol() {
    if (this.SerbestFatura.TevkivatKdv != 0 && this.SerbestFatura.TevkivatKdv != null && this.SerbestFatura.TevkivatKdv !=
      '') {
      if (this.SerbestFaturaDetay.TevkifatDetayOran != 0 && this.SerbestFaturaDetay.TevkifatDetayOran != null && this.SerbestFaturaDetay
        .TevkifatDetayOran != '') {

        this.text1 = 'Serbest Fatura Detay Ekranında Tevkifat Oranı Seçilidir.'
        this.snackbar = true
        this.SerbestFatura.TevkivatKdv = null

      } else {

        this.detaytevkifat = false
        this.SerbestFaturaDetay.TevkifatDetayOran = 0
        this.SerbestFaturaDetay.TevkifatDetayTutar = 0
      }


    } else {
      this.detaytevkifat = true
    }
  }

  function anatevkifatiptal() {

    if (this.SerbestFatura.TevkivatKdv === 0 || this.SerbestFatura.TevkivatKdv === null || this.SerbestFatura.TevkivatKdv ===
      '') {
      this.detaytevkifat = true
    }
  }

  function Tevkifatkdvhesapla() {

    var params1 = {
      TevkifatOran: this.SerbestFaturaDetay.TevkifatDetayOran,
      KdvTutar: this.SerbestFaturaDetay.KdvTutar
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetWithHoldingAmount', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.TevkifatDetayTutar = response.body.TevkifatTutar
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }

  function satirekle() {
    this.SerbestFaturaDetay.Referans.Kod = null
    this.satirdialog = true
    this.satirkaydetbuton = true
    this.satirguncellebuton = false

    this.SerbestFaturaDetay.MuhasebeKodu = ''
    this.SerbestFaturaDetay.MuhasebeKodu = ''
    this.SerbestFaturaDetay.Aciklama = ''
    this.SerbestFaturaDetay.LineNote = ''
    this.SerbestFaturaDetay.Referans.Kod = null
    this.SerbestFaturaDetay.Masraf.Code = null
    this.SerbestFaturaDetay.Miktar = ''
    this.SerbestFaturaDetay.Birim = ''
    this.SerbestFaturaDetay.BirimFiyat = 0
    this.SerbestFaturaDetay.Tutar = 0
    this.SerbestFaturaDetay.DovizTutar = 0
    this.SerbestFaturaDetay.IskontoYuzde = 0
    this.SerbestFaturaDetay.IskontoTutar = 0
    this.SerbestFaturaDetay.KdvTip = ''
    this.SerbestFaturaDetay.KdvYuzde = 0
    this.SerbestFaturaDetay.KdvTutar = 0
    this.SerbestFaturaDetay.KdvMuhKodu = ''
    this.SerbestFaturaDetay.IskMuhKodu = ''
    this.SerbestFaturaDetay.KdvKodu = ''
    this.SerbestFaturaDetay.IstisnaKodu = ''
    this.SerbestFaturaDetay.TevkifatKodu = ''
    this.SerbestFaturaDetay.Tip = ''
    this.SerbestFaturaDetay.TevkifatDetayTutar = 0
    this.SerbestFaturaDetay.TevkifatDetayOran = ''
    this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi = ''
    this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi = ''
    this.SerbestFaturaDetay.TeslimBilgileri.BinaNo = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti = ''
    this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu = ''
    this.SerbestFaturaDetay.TeslimBilgileri.KabinNo = ''
    this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi = ''
    this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme = ''
  }

  function satirkaydet() {

    if (this.SerbestFaturaDetay.DovizTutar > 0) {
      var n = this.SerbestFaturaDetay.DovizTutar
      this.SerbestFaturaDetay.DovizTutar = n.toFixed(4)

    }

    var satir = {
      TeslimBilgileri: {
        SokakAdi: this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi,
        BinaAdi: this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi,
        BinaNo: this.SerbestFaturaDetay.TeslimBilgileri.BinaNo,
        TeslimSehir: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir,
        TeslimPostaKodu: this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu,
        TeslimUlke: this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke,
        TeslimSarti: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti,
        GTIPNo: this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo,
        TransferKodu: this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu,
        KabinNo: this.SerbestFaturaDetay.TeslimBilgileri.KabinNo,
        KabinAdedi: this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi,
        KabinCinsi: this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi,
        TeslimOdeme: this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme
      },
      MuhasebeKodu: this.SerbestFaturaDetay.MuhasebeKodu,
      Aciklama: this.SerbestFaturaDetay.Aciklama,
      Referans: {
        Kod: this.SerbestFaturaDetay.Referans.Kod
      },
      Masraf: {
        Code: this.SerbestFaturaDetay.Masraf.Code
      },
      Miktar: this.SerbestFaturaDetay.Miktar,
      LineNote: this.SerbestFaturaDetay.LineNote,
      Birim: this.SerbestFaturaDetay.Birim,
      BirimFiyat: this.SerbestFaturaDetay.BirimFiyat,
      Tutar: this.SerbestFaturaDetay.Tutar,
      TevkifatDetayTutar: this.SerbestFaturaDetay.TevkifatDetayTutar,
      DovizTutar: this.SerbestFaturaDetay.DovizTutar,
      TevkifatDetayOran: this.SerbestFaturaDetay.TevkifatDetayOran,
      IskontoYuzde: this.SerbestFaturaDetay.IskontoYuzde,
      IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
      KdvKodu: this.SerbestFaturaDetay.KdvKodu,
      KdvMuhKodu: this.SerbestFaturaDetay.KdvMuhKodu, //
      IskMuhKodu: this.SerbestFaturaDetay.IskMuhKodu, //
      KdvTutar: this.SerbestFaturaDetay.KdvTutar,
      KdvTip: this.SerbestFaturaDetay.KdvTip,
      KdvYuzde: this.SerbestFaturaDetay.KdvYuzde,
      IstisnaKodu: this.SerbestFaturaDetay.IstisnaKodu,
      TevkifatKodu: this.SerbestFaturaDetay.TevkifatKodu,
      Tip: this.SerbestFaturaDetay.Tip,
      AdresBilgi: {
        Unvani: null,
        Unvani2: null,
        Adres1: null,
        Adres2: null,
        IlceSehir: null,
        Email: null,
        VergiDairesi: null,
        VergiNo: null,
        TcKimlikNo: null,
        Adi: null,
        Soyadi: null,
        TUnvani: null,
        DigerAdi: null,
        OnAdiEki: null
      },
      EfaturaDetayBilgileri: {
        SiparisID: null,
        SiparisTarihi: null
      },
      AdresBilgi: {
        Unvani: null,
        Unvani2: null,
        Adres1: null,
        Adres2: null,
        IlceSehir: null,
        Email: null,
        VergiDairesi: null,
        VergiNo: null,
        TcKimlikNo: null,
        Adi: null,
        Soyadi: null,
        TUnvani: null,
        DigerAdi: null,
        OnAdiEki: null
      }
    }

    this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar + satir.Tutar
    this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv + satir.KdvTutar
    if (this.detaytevkifat === false) {

      var params1 = {
        TevkifatOran: this.SerbestFatura.TevkivatKdv,
        KdvTutar: this.SerbestFaturaDetay.KdvTutar
      }

      this.$http.post(auth.API_URL + 'api/Helpers/GetWithHoldingAmount', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv + response.body.TevkifatTutar
        this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto + satir.IskontoTutar
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-Tevkifat Hesapla'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable-Tevkifat Hesapla'
          this.snackbar = true
        }
      })

    } else {

      this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv + satir.TevkifatDetayTutar
      this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto + satir.IskontoTutar
    }

    this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.ToplamTutar -
      this.SerbestFatura.Tutarlar.Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv
    this.SerbestFaturaDetayList.push(satir)
    this.satiritems = this.SerbestFaturaDetayList

    console.log(this.satiritems)
    this.satirdialog = false

  }



  function Kaydet() {
    this.$validator.validateAll().then((result) => {

      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        if (this.nefaturasi = 'gelen') {
          this.SerbestFatura.Serbest = false
        }

        this.SerbestFatura.SirketKodu = credentials.SirketKodu

        if (this.datearsiv != null && this.datearsiv != '') {
          this.SerbestFatura.EarsivBilgi.OdemeTarihi = this.datearsiv
        }
        this.SerbestFatura.Detay = this.satiritems

        var params = this.SerbestFatura
        this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      } else {
        console.log('')
      }

    })
  }

  function FaturaGuncelle() {
    this.$validator.validateAll().then((result) => {

      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        if (this.nefaturasi = 'gelen') {
          this.SerbestFatura.Serbest = false
        }
        this.SerbestFatura.SirketKodu = credentials.SirketKodu
        this.SerbestFatura.Update = true

        if (this.datearsiv != null && this.datearsiv != '') {
          this.SerbestFatura.EarsivBilgi.OdemeTarihi = this.datearsiv
        }

        this.SerbestFatura.Detay = this.satiritems
        var params = this.SerbestFatura

        this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      } else {
        console.log('')
      }

    })
  }

  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    console.log(today + 'today değeri')
    return today
  }

  function iskontooranhesapla() {
    var params1 = {
      Tutar: this.SerbestFaturaDetay.Tutar,
      IskontoTutar: this.SerbestFaturaDetay.IskontoTutar
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetDiscountRate', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.IskontoTutar = response.body.IskontoOran
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }

  function iskontohesapla() {


    var params1 = {
      Tutar: this.SerbestFaturaDetay.Tutar,
      IskontoOran: this.SerbestFaturaDetay.IskontoYuzde
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetDiscountAmount', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.IskontoTutar = response.body.IskontoTutar
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }

  function kdvhesapla() {

    var params1 = {
      KdvTip: this.SerbestFaturaDetay.KdvTip,
      Tutar: this.SerbestFaturaDetay.Tutar,
      IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
      KdvOran: this.SerbestFaturaDetay.KdvYuzde
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetTaxAmount', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.KdvTutar = response.body.KdvTutar
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Kdv Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Kdv Hesapla'
        this.snackbar = true
      }
    })
  }

  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }

  function carigetir(v) {

    this.statecari = []
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (v.length >= 0) {
      this.loading = true
      var query = {
        q: v,
        c: credentials.SirketKodu,
      }
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', query, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.statecari = response.body

          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.Success = false
            this.Error = 'Service Unavailable'
          } else {
            this.Success = false
            this.Error = response.statusText
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function beforeMount() {

    this.SerbestFatura.Tarih = getDateNow()
    this.SerbestFatura.Vade = getDateNow()

    this.SerbestFaturaDetayList = []

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params1 = {
      CompanyCode: credentials.SirketKodu,
    }

    this.$http.post(auth.API_URL + 'api/Reference/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.referaslist = response.body

      this.SerbestFatura.Referans.Kod = null

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
    this.SerbestFatura.Referans.Kod = null

    this.$http.post(auth.API_URL + 'api/Definitions/GibSerialList', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.gibseri = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/doctype/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.EvrakTipi1 = response.body
      this.SerbestFatura.FaturaTip = String(response.body.FaturaTip)
    }, (response) => {
      if (response.status === 0) {
        console.log('')
      } else {
        console.log('')
      }
    })


    this.$http.post(auth.API_URL + 'api/currency/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz Tipi'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz Tipi'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
      }
    })
    this.SerbestFatura.Masraf.Code = null
    this.SerbestFatura.Referans.Kod = null




if (this.$route.query.islem == "yenigelenevrak") {
console.log('yeni gelen evrak')
        this.nefaturasi = 'gelen'
        this.faturatipi = [];
        var kayit = {
          text: 'Alış Faturası',
          value: 0
        }
        this.faturatipi.push(kayit);
        kayit = {
          text: 'Satış İadesi',
          value: 1
        }
        this.faturatipi.push(kayit);
        this.SerbestFatura.GibSeri = null,
          this.gibserigoster = false;
        this.gibseri = [];
        this.sayfabaslik = 'Gelen Fatura Yeni'
        this.SerbestFatura.CariAktarma = false;
}


    if (this.$route.query.islem == "get" || this.$route.query.islem == "gelenevrak") {
      this.faturagosterbtn = true
      this.loadingdialog = true
      this.guncellebuton = true
      this.kaydetbuton = false
      this.seridisable = true
      this.aktifdate = true


      var params2 = {
        SirketKodu: credentials.SirketKodu,
        Tarih: this.$route.query.ft,
        CariKod: this.$route.query.ck,
        EvrakTipi: null,
        EvrakSeri: null,
        Evrakno: this.$route.query.en,
        Nereden: this.$route.query.ner,
        Serbest: this.$route.query.sb,
      }



      if (this.$route.query.islem == "gelenevrak") {
        this.nefaturasi = 'gelen'
        this.faturatipi = [];
        var kayit = {
          text: 'Alış Faturası',
          value: 0
        }
        this.faturatipi.push(kayit);
        kayit = {
          text: 'Satış İadesi',
          value: 1
        }
        this.faturatipi.push(kayit);
        this.SerbestFatura.GibSeri = null,
          this.gibserigoster = false;
        this.gibseri = [];
        this.sayfabaslik = 'Gelen Fatura Düzenle'
        this.SerbestFatura.CariAktarma = false;
      }

      this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceGet', params2, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SerbestFatura = response.body

        var statecariyeni = [{
          text: response.body.Cari.Kod + '-' + response.body.Cari.Unvan,
          id: response.body.Cari.Kod
        }]

        this.statecari = statecariyeni

        if (this.nefaturasi != 'gelen') {
          this.SerbestFatura.EFaturaShowID.EFaturaID = response.body.EFaturaShowID.EFaturaID
          this.SerbestFatura.EFaturaShowID.EFaturaGuid = response.body.EFaturaShowID.EFaturaGuid
          this.guidim = response.body.EFaturaShowID.EFaturaGuid
          this.idim = response.body.EFaturaShowID.EFaturaID
        }

        this.satiritems = response.body.Detay
        this.loadingdialog = false
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.loadingdialog = false

        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.loadingdialog = false

        }
      })
    }



  }


  function earsivbilgigir() {
    this.dialogearsiv = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    //web adreslerini çekelim
    var params = {
      CompanyCode: credentials.SirketKodu,
      Type: '305'
    }
    this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.webadresleri = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-web adresleri'
        this.snackbar = true
      } else {

        this.text1 = 'Service Unavailable-web adresleri'
        this.snackbar = true
      }
    })


    //ödeme şekillerini çekelim
    var params = {
      CompanyCode: credentials.SirketKodu,
      Type: '306'
    }
    this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.odemesekilleri = response.body
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable-ödeme şekli'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-ödeme şekli'
        this.snackbar = true
      }
    })
    // ödeme araçlarını alalalım
    var params = {
      CompanyCode: credentials.SirketKodu,
      Type: '307'
    }
    this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.odemearaci = response.body
    }, (response) => {
      if (response.status === 0) {

        this.text1 = 'Service Unavailable-ödeme aracı'
        this.snackbar = true
      } else {

        this.text1 = 'Service Unavailable-ödeme aracı'
        this.snackbar = true
      }
    })



  }

  function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function ekle() {

    this.Current.Contract.ContractDate = this.SerbestFatura.Tarih

    var current = this.Current
    this.$http.post(auth.API_URL + 'api/Current/New', current, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (response.body.Status === true) {
        this.text1 = 'Kayıt Eklendi'
        this.snackbar = true
      } else if (response.body.Status === false) {
        this.text1 = 'Hata Oluştu'
        this.snackbar = true
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.body.StatusText
        this.snackbar = true
      }
    })
  }

  function guncelle() {

    this.$validator.validateAll().then((result) => {
      if (result) {

        this.Current.Contract.ContractDate = this.SerbestFatura.Tarih
        var current = this.Current
        this.$http.post(auth.API_URL + 'api/Current/Update', current, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status === true) {
            this.text1 = 'Bilgiler Güncellendi'
            this.snackbar = true
          } else if (response.body.Status === false) {
            this.text1 = 'Hata Oluştu'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>